import { cx } from 'classix'
import type { ComponentProps, ReactNode } from 'react'
import { ButtonBase } from '../../Base/ButtonBase'
import { BUTTON_VARIANT } from '../../Button.types'

import styles from './ButtonIconTransparent.module.css'

interface TransparentProps extends ComponentProps<'button'> {
	readonly variant?: BUTTON_VARIANT
}

export function ButtonIconTransparent(props: TransparentProps): ReactNode {
	const { variant = BUTTON_VARIANT.DEFAULT, className, ...rest } = props

	return <ButtonBase {...rest} className={cx(className, styles[variant])} />
}
